module.exports = __webpack_public_path__ + "static/media/collapse-arrow-up.dc77e0cf.svg";